module.exports = __webpack_public_path__ + "static/img/ind_ban_05.59a8648e.jpeg";